import React from 'react'
import { Container, ContainerInterno, BoxCol6, TagContador, TituloBanner, TextoBanner, Imagem } from './Styled'
import bgBannerDesktop from 'images/renovacao-antecipada-2026/bgBannerPrincipal.jpg'
import bgBannerMobile from 'images/renovacao-antecipada-2026/bg-nao-seja-mais-demitido-mobile.jpg'
import sncp2026 from 'images/renovacao-antecipada-2026/sncp-2026.png'
import TarjaCountdown from '../TarjaCountdown/TarjaCountdown'

export default function BannerPrincipal ({ nome, desconto, dataFim }) {

	return (
		<Container bgDesktop={bgBannerDesktop} bgMobile={bgBannerMobile} id='bannerPromocao'>
			<ContainerInterno>

				{/* Textos Banner */}
				<BoxCol6 className='boxTextos'>

					{/* Tag Contador */}
					<TagContador><span>ESTA OFERTA EXCLUSIVA PARA<br /> ASSINANTES EXPIRA EM:</span></TagContador>

					{/* Tarja */}
					<TarjaCountdown
						date={new Date()}
						to={dataFim}
						onFinish={() => window.location.reload()}
					/>

					{/* Título Banner */}
					<TituloBanner><strong>PARABÉNS</strong>, {nome.split(" ")[0]}!<br /> VOCÊ <strong>GANHOU<br /> {desconto}% DE DESCONTO</strong><br /> PARA RENOVAR SUA ASSINATURA HOJE</TituloBanner>

					{/* Texto Banner */}
					<TextoBanner><strong>Assinante paga menos:</strong> você abate mais <strong>+{desconto}%</strong> por cima dos<br /> descontos absurdos da Semana Nacional dos Concursos<br /> Públicos.</TextoBanner>

				</BoxCol6>

				{/* Textos Direita */}
				<BoxCol6>
					
					{/* Imagem */}
					<Imagem src={sncp2026} />

				</BoxCol6>

			</ContainerInterno>
		</Container>
	)
}
